export default __webpack_public_path__ + "static/media/2-star.8c4543f5.png";